const ArticleContent =  [
{
    name:"sets",
    title:"My favorite make-up and skincare sets",
    featured:"false",
    category:"Beauty, Skin",
    photo:"https://tz-mag-media.s3.ap-southeast-1.amazonaws.com/wp-content/uploads/2020/05/26172445/18-KBeauty-Brands-V1.jpg",
    featuredtext:"You will never know what you get with sets, it might be just another group of meh products, but you will never know, you might find your next holy grail brand.",
    content: [
        `Here are my top sets:
        
        1. The CosRX Favorites Best Seller
        This is great because CosRX is my favorite brand. Their cleansers and toners are a great must haves for cleaning.

        2. Any Benefit Gift Set
        Benefit usually have sales. If you want to try out a single product, might as well buy the set since you get as much as 50% savings.

        3. Squad Cosmetics Set
        Squad cosmetics is a very affordable brand. Nothing screams more affordable than them selling gift sets which give you more discounts.

        4. Innisfree Gift Sets
        I love Innisfree because they have very pleasant smelling products. Each line has different types of products. So getting the set can help you try each line without the commitment.
    `]
},

{
    name:"retinol",
    title:"All about Retinol",
    featured:"false",
    category:"Skin",
    photo:"https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/retinol-serums-lede-1633719355.png?crop=1.00xw:1.00xh;0,0&resize=1200:*",
    featuredtext:"Skin and beauty products often contain both retinoids and retinols, as well as other ingredients like peptides and antioxidants.",
    content: [
        ` The benefits of retinol are typically enhanced when it is combined with other skin care ingredients. Retinol is the active form of vitamin A that can be used to target several skin concerns. 
        
        Retinol can be found in many skin care products, including serums, moisturizers and eye creams. Topical retinoids can help increase cell turnover in the skin, which reduces the appearance of fine lines and wrinkles, diminishes pore size, smoothes uneven texture and improves overall radiance.
        
        They also promote collagen production, which helps strengthen the skin’s structure and slows the formation of fine lines and wrinkles. When retinol is incorporated into age-preventive skin care routines, it helps accelerate skin renewal, enhance collagen production and reduce the appearance of aging, uneven texture and age spots.`
    ]
},

{
    name:"cosrx",
    title:"7 CosRX Products you should try",
    featured:"false",
    category:"Skin",
    photo:"http://cdn.shopify.com/s/files/1/0025/1563/2174/articles/cosrx_best_korean_beauty_1.jpg?v=1584848836",
    featuredtext:"There's nothing more satisfying than checking your cart out from one brand. Talk about all the shipping fee saved.",
    content: [
        `This is dedicated to all of my friends, here are other CosRX products you should try:
        
        1. Low pH Good Morning Gel Cleanser 
        2. Salicylic Acid Daily Gentle Cleanser
        I think I mention CosRX too much in this blog. This is not sponsored, but baka naman, haha! My mom loved CosRX so much because it helped smooth her skin. Use the Low pH in the morning and the salicylic acid at night.

        
        3. Acne Pimple Master Patch
        4. ClearFit Pimple Patch
        These pimple patches really work, the difference is that the acne pimple has more hydrogel while on the other hand the ClearFit is thinner, which makes it good for wearing under make up.

        5. Ultimate Nourishing Rice Overnight Mask
        6. Propolis Honey Overnight Mask    
        Both masks have a clean residue. I think I liked the honey more because of the cooling effect. But both of these for sure made my face moisturized when I wake up in the morning.
        
        7. AHA/BHA Clarifying treatment Toner
        The Holy grail of all toners. This AHA/BHA toner is good for white heads and black heads. Just use it once-twice a day for maximum effect. `

        
    ]
},

{
    name:"skincare",
    title:"I just have to say this about Skincare",
    featured:"false",
    category:"Skin",
    photo:"https://images.everydayhealth.com/images/reasons-a-healthy-skin-care-routine-is-good-for-your-mental-health-722x406.jpg",
    featuredtext:"Skin care is important. It helps you clear away debris and dirt that clogs your pores and dulls your complexion. ",
    content: [
        `It also helps keep your skin looking younger and more youthful.Adopting a skin care routine doesn't need to be an all-or-nothing proposition. You don't need to buy the most expensive, high-end products on the market if you're not ready for that kind of commitment.
        
        You can start with gentle cleansing with something like Cetaphil or Purpose, which are both very economical, mild cleansers that are gentle enough for every day use. Once you get used to that, you may want to try a toner, which will help remove oil from you skin and make it feel tighter and cleaner. 
        
        You may also want to try a moisturizer, especially if you have dryer skin.To counter the effects of aging and sun exposure, try an exfoliator like Aveeno Positively Radiant Brightening Cleanser twice a week to help slough away dead skin cells and reveal smoother, brighter skin underneath. 
        
        If you want to add more products as time goes on, consider adding a retinol product or a serum containing Vitamin C, antioxidants or peptides to help minimize wrinkles and fine lines.`
    ]
},

{
    name:"skincaremakeup",
    title:"5 Tips I always say to my friends",
    featured:"true",
    category:"Beauty, Skin",
    photo:"https://www.news-medical.net/images/Article_Images/ImageForArticle_22262_16478805220232846.jpg",
    featuredtext:"Make up and skin care can be intimidating to beginners. Here are my favorite tips: ",
    content: [
        `The following are some tips for good skin and beauty:

        1. Start with skincare. A good skincare routine can give your face an inner glow. This in turn will make your face a good canvas when starting your make-up.
        
        2. Practice and explore what looks good for your facial features. Although trends make you look better, your personal style will always make you confident and stand out from the rest.
        
        3. Keep it simple. If you are just starting with makeup, keep it simple by applying a little foundation and concealer, mascara and lip gloss or balm to start off the day.
        
        4. Invest in a good quality brush set which is easy to apply on the go and to touch up throughout the day if needed.
        
        5. Stay hydrated! Always keep your perfumes, body sprays, etc., in a well-ventilated area because they can contribute to premature aging of the skin`
    ]
},

]

export default ArticleContent